module.exports = __webpack_public_path__ + "img/pk.7453bb6b.png";